import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TableModule } from 'primeng/table';
import { AbstractControl } from '@angular/forms';

import { AccordionComponent } from '@shared/components/accordion/accordion.component';
import { InputQuantityComponent } from '@shared/components/form-elements/input-quantity/input-quantity.component';
import { SwitcherComponent } from '@shared/components/form-elements/switcher/switcher.component';
import { ButtonComponent } from '@shared/components/button/button.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'import-products',
  imports: [
    CommonModule,
    RouterModule,
    TableModule,
    AccordionComponent,
    InputQuantityComponent,
    SwitcherComponent,
    ButtonComponent,
    TranslateModule,
  ],
  templateUrl: './import-products.component.html',
  styleUrl: './import-products.component.scss',
})
export class ImportProductsComponent {
  @Input() control?: AbstractControl | null;

  constructor() {}
}
